import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.auroragh.com/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('aurora_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('aurora_token');
      localStorage.removeItem('aurora_user');
      window.location.href = (process.env.REACT_APP_LOYALTY_URL || 'https://app.auroragh.com') + '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;